module.exports = __webpack_public_path__ + "static/2-d6406f60d7fb01cd5b94c9125a1251f7.jpg";